import SeoHack from './SeoHack'

export default SeoHack